// Tagline aplikasi -- SATU sumber utk halaman login (AuthShell) & sidebar (AppLayout).
// Sejak Okt 2026 tagline TIDAK lagi tercetak di gambar logo sidebar (assets/logo-aura.png = wordmark saja,
// dipotong dari logo.png lama) supaya teksnya bisa diubah tanpa membuat gambar baru.
export const TAGLINE = "Aplikasi Unit Record & Administrasi Peserta Didik";
